// extracted by css-extract-rspack-plugin
export default {"panel":"FiZIm","reactFlow":"yXhU2","controls":"p7vhi"};